import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import * as pathsActions from './pathsSlice';
import { boundingExtent } from 'ol/extent';
import { fromLonLat } from 'ol/proj';
import { selectAllNodes } from '../map/slice/mapSelectors';
import { RootState } from '@/store';
import { useMapContext } from '../map/context/MapContext';

export function ZoomPath() {
  const { map } = useMapContext();
  const dispatch = useDispatch();
  const zoomPathId = useSelector(pathsActions.selectZoomPathId);
  const zoomPath = useSelector((state: RootState) => state.paths.paths)[
    zoomPathId
  ];
  const nodes = useSelector(selectAllNodes);
  const zoomPathNodeIds = zoomPath?.path_node_ids;

  useEffect(() => {
    if (
      !map ||
      !zoomPathId ||
      !zoomPathNodeIds ||
      zoomPathNodeIds.length == 0
    ) {
      return;
    }

    const pathPositions = zoomPathNodeIds
      .map((nodeId) => [nodes[nodeId]?.lat, nodes[nodeId]?.lng])
      .filter((latlng) => latlng[0] && latlng[1])
      .map(([lat, lon]) => fromLonLat([Number(lon), Number(lat)]));

    const pathBounds = boundingExtent(pathPositions);

    if (pathBounds?.length < 4) {
      return;
    }

    map.getView().fit(pathBounds, {
      padding: [100, 50, 50, 50],
      duration: 1000,
    });
    dispatch(pathsActions.zoomToPath(null));
    return;
  }, [zoomPathId, map]);

  return null;
}
